// Detect an HLS playlist URL (.m3u8, optionally followed by a query or hash).
export function isHlsUrl(url) {
  return typeof url === "string" && /\.m3u8(\?|#|$)/i.test(url);
}

// Parse the "#t=<seconds>" media-fragment that the resume-cookie / deep-link
// logic appends to a URL, returning the start time in seconds (0 when absent
// or invalid). Used to seek HLS playback, where the #t= fragment can't be relied
// on the way it is for a direct file <src>.
export function parseStartSeconds(urlTimestamp) {
  if (!urlTimestamp) return 0;
  const match = String(urlTimestamp).match(/#t=(\d+(?:\.\d+)?)/);
  if (!match) return 0;
  const seconds = Number(match[1]);
  return Number.isFinite(seconds) && seconds > 0 ? seconds : 0;
}
